import { render, staticRenderFns } from "./view.vue?vue&type=template&id=671bc2a6&scoped=true&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"
import style0 from "./view.vue?vue&type=style&index=0&id=671bc2a6&lang=stylus&scoped=true&"
import style1 from "./view.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671bc2a6",
  null
  
)

export default component.exports